import { PropsWithChildren } from 'react';
import {
    ApolloClient,
    ApolloLink,
    ApolloProvider,
    createHttpLink,
    InMemoryCache,
} from '@apollo/client';
import { Env } from './Env.ts';
import { AuthLayout } from './Layouts/AuthLayout.tsx';
import { Center } from '@mantine/core';
import Session from 'supertokens-auth-react/recipe/session';

/**
 * Esto es como una alternativa a usar directametne ApolloProvider.
 *
 * Es un buen lugar para encapsular el header
 *
 * TODO: creo que todo esto se podría simplificar con https://www.apollographql.com/docs/react/api/link/apollo-link-context (lo que entiendo que haría es pedir el token en cada request, y soporta asyncronico, así que lo podemos sacar de la sesión
 *
 * @param props
 * @constructor
 */
export function OwnApolloProvider(props: PropsWithChildren) {
    const checkingSession = Session.useSessionContext();
    if (checkingSession.loading)
        return (
            <AuthLayout>
                <Center>cargando sesión...</Center>
            </AuthLayout>
        );

    if (!checkingSession.doesSessionExist) return props.children;

    const client = new ApolloClient({
        cache: new InMemoryCache({
            typePolicies: {
                Customer: {
                    keyFields: ['cid'],
                },
                //Probando si esto ayuda
                pagos: {
                    keyFields: ['import_id'],
                },
                Query: {
                    fields: {
                        // ultimasSuscripcionesConnection: {
                        //     // Don't cache separate results based on
                        //     // any of this field's arguments.
                        //     keyArgs: ['filters', 'sparkline'], // Concatenate the incoming list items with
                        //     // the existing list items.
                        //     merge: mergeCursorStyle,
                        // },
                        bloqueosConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['incluirViejos', 'filtros'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                        eventsConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['filters'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                        trialsActivosConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['filters'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                        contratacionesConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['filters'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                        ipnConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['filters'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                        zenriseWebhooksConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['filters'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                        invoicesZenRiseConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['filters'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                        procesosDiariosConnection: {
                            // Don't cache separate results based on
                            // any of this field's arguments.
                            keyArgs: ['filters'], // Concatenate the incoming list items with
                            // the existing list items.
                            merge: mergeCursorStyle,
                        },
                    },
                },
            },
        }),
        link: getConfigConCookies(),
    });
    return <ApolloProvider client={client}>{props.children}</ApolloProvider>;
}

function getConfigConCookies(): ApolloLink {
    return createHttpLink({
        uri: Env.GATEWAY_URL,
        //Si no entendí mal, esto es para que mande las cookies en las consultas
        credentials: 'include',
    });
}

interface CursorStyle<Node> {
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean };
    edges: Node[];
}

/**
 * Mergea los resultados al estilo Cursor, siempre agregando al final.
 */
function mergeCursorStyle<Node>(
    existing: CursorStyle<Node> | undefined,
    incoming: CursorStyle<Node>
): CursorStyle<Node> {
    // debugger;
    return {
        pageInfo: incoming.pageInfo,
        edges: [...(existing?.edges ?? []), ...incoming.edges],
    };
}
